import FileSaver from 'file-saver'

export function criarLinkRelatorio(relatorio, nome) {
    FileSaver.saveAs(relatorio, nome);
}